import { useNavigate } from "react-router-dom";
import { UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang, LANGUAGES } from "@/lib/i18n";
import { NightToggle } from "@/components/NightToggle";

export function HeaderTools() {
  const { user } = useAuth();
  const { lang, setLang, t } = useLang();
  const nav = useNavigate();
  return (
    <div className="header-tools">
      <NightToggle t={t} />
      <label className="lang-btn lang-pick" aria-label={t("Language")}>
        {lang.toUpperCase()}
        <select value={lang} onChange={(e) => setLang(e.target.value)} data-testid="lang-toggle" aria-label={t("Language")}>
          {LANGUAGES.map(([c, n]) => <option key={c} value={c}>{n}</option>)}
        </select>
      </label>
      <button type="button" className={`header-btn ${user ? "header-btn-on" : ""}`} data-testid="account-button"
        aria-label={t("Account")} onClick={() => nav(user ? "/account" : "/login")}>
        {user?.picture ? <img src={user.picture} alt="" className="avatar" /> : <UserRound size={20} />}
      </button>
    </div>
  );
}
